module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('header', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro__content"
  }, [(_vm.type === 'story') ? _c('div', {
    staticClass: "intro__time",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.$content.createdAt)))]) : _vm._e(), _c('div', {
    staticClass: "intro__title",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm.$content.title))]), (_vm.$content.description) ? _c('div', {
    staticClass: "intro__description",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm.$content.description))]) : _vm._e(), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.scrollVisible) ? _c('scroll-marker', {
    staticClass: "intro__scroll",
    attrs: {
      "dark-mode": true
    },
    on: {
      "click": _vm.scroll
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    ref: "image",
    staticClass: "intro__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.$content.pageMedia.image.url,
      "alt": "image"
    }
  })])]), _c('main', {
    staticClass: "main"
  }, [_vm._l((_vm.$content.widgets), function(widget) {
    return [(_vm.validateWidget(widget)) ? _c('appearance-wrapper', [_c(_vm.getWidgetType(widget.type), {
      key: widget.id,
      tag: "component",
      attrs: {
        "content": widget
      }
    })], 1) : _vm._e()]
  })], 2), _c('appearance-wrapper', [_c('the-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a0c2650","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/index.vue
// module id = 498
// module chunks = 0